import { ReactSimpleComponentProps } from '@/custom-types';
import { useMemo, useState } from 'react';
import { AddExpenseFormModalContext, AddExpenseFormModalContextProps } from './AddExpenseFormModalContext';

export const AddExpenseFormModalContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [propertyId, setPropertyId] = useState<string | null>(null);
  const [contractId, setContractId] = useState<string | null>(null);
  const [incidentId, setIncidentId] = useState<string | null>(null);

  const actions = useMemo<Omit<AddExpenseFormModalContextProps, 'propertyId' | 'contractId' | 'incidentId' | 'isOpen'>>(() => ({
    openModal: (id: string, options?: { contractId?: string; incidentId?: string }) => {
      setPropertyId(id);
      setContractId(options?.contractId || null);
      setIncidentId(options?.incidentId || null);
      setIsOpen(true);
    },

    closeModal: () => {
      setIsOpen(false);
      setPropertyId(null);
      setContractId(null);
      setIncidentId(null);
    },
  }), []);

  return (
    <AddExpenseFormModalContext.Provider value={{ ...actions, isOpen, propertyId, contractId, incidentId }}>
      {children}
    </AddExpenseFormModalContext.Provider>
  );
};

